<template>
  <div class="hell">
    <div class="header">
      <img src="../assets/logo.png" alt="" />
      <p>创新与知识产权管理人才服务系统</p>
    </div>
    <div class="login">
      <div class="login_div">
        <div class="titleNew">
          <img src="../assets/login.png" alt="" />
        </div>
        <p class="goindex" @click="logo">返回首页</p>
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-position="left" label-width="0px"
          class="login-form">
          <div class="tabStyle">
            <div :class="activeTab == 1 ? 'active' : ''" @click="changeLogin(1)" style="margin-right:50px">验证码登录<span
                :class="activeTab == 1 ? 'actives' : ''"></span></div>
            <div :class="activeTab == 2 ? 'active' : ''" @click="changeLogin(2)">密码登录<span
                :class="activeTab == 2 ? 'actives' : ''"></span></div>

          </div>
          <div style="height:326px">
            <div v-if="activeTab == 2"><!-- <div style="height: 10px"></div> -->
              <el-form-item prop="username">
                <el-input v-model="loginForm.username" type="text" auto-complete="off" placeholder="请输入身份证件号码/手机号/电子邮箱"
                  class="shortInput">
                </el-input>
              </el-form-item>
              <!-- <div style="height: 10px"></div> -->

              <el-form-item v-if="visible" prop="passwd">
                <el-input v-model="loginForm.passwd" type="text" auto-complete="off" placeholder="请输入密码"
                  @keyup.enter.native="handleLogin" class="shortInput">
                </el-input>
                <img src="../image/iframe/looky.png" @click="showPass('show')" class="icon-yincan scrimg" />
              </el-form-item>

              <el-form-item class="looky" v-else prop="passwd">
                <el-input v-model="loginForm.passwd" type="password" auto-complete="off" placeholder="请输入密码"
                  @keyup.enter.native="handleLogin">
                </el-input>
                <img src="../image/iframe/lookn.png" @click="showPass('show')" class="icon-xianshi scrimg" />
              </el-form-item>

              <!-- <div class="divcss" v-show="msg">
            <div class="xxxx">x</div>
            <p>{{ msg }}</p>
          </div> -->
              <div style="display: flex" class="yanzhenma">
                <el-form-item prop="check_code">
                  <el-input style="
                  display: flex;
                  align-items: center;
                  width: 214px;
                  justify-content: flex-end;
                " placeholder="请输入验证码" v-model="loginForm.check_code" @keyup.enter.native="handleLogin"></el-input>
                </el-form-item>

                <div
                  style="width: 130px; height: 50px; margin: 0 auto;display: flex;align-items: center;justify-content: space-around;">
                  <img style="width: 60%; height: 30px" :src="register.image" @click="Changeone()" />
                  <span style="color: red;">两位字符验证码</span>
                  <!-- <p
                style="
                  font-size: 6px;
                  display: flex;
                  align-items: center;
                  margin-left: 12px;
                "
                @click="Changeone()"
              >
                看不清&nbsp;换一张
              </p> -->
                </div>

                <!-- </el-form-item> -->
              </div>
            </div>
            <div v-else>
              <el-form-item prop="telephone">
                <el-input v-model="loginForm.telephone" type="text" placeholder="请输入手机号" class="shortInput" clearable>
                </el-input>
              </el-form-item>
              <el-form-item prop="msgCode">
                <div style="display:flex;justify-content: space-around;box-sizing: border-box;">
                  <el-input v-model="loginForm.msgCode" type="text" auto-complete="off" style="flex:1" clearable
                    placeholder="请输入短信验证码">
                  </el-input>
                  <div style="width: 110px; height: 50px;margin-left:10px;">
                    <el-button @click="getCode" type="success" :disabled="disabled" v-show="!is_pause">获取验证码</el-button>
                    <span v-show="is_pause == true">有效时间：{{ countdown }}s</span>
                  </div>
                </div>
              </el-form-item>
              <!-- <div style="height:77px"></div> -->
            </div>

            <el-form-item style="width: 100%; margin: auto">
              <el-button :loading="loading" size="medium" type="primary" @click.native.prevent="handleLogin">
                <span v-if="!loading">登&nbsp;&nbsp;录</span>
                <span v-else>登 录 中...</span>
              </el-button>
            </el-form-item>
            <!-- <div style="height: 20px"></div> -->
            <p style="
              width: 92%;
              margin: 0 auto;
              line-height: 40px;
              font-size: 15px;
              display: flex;
              justify-content: space-between;
            ">
              <a @click="remberPass" class="remberPass">忘记密码</a>
              <a @click="logon" class="register">点击注册</a>
              <!-- <div style="height: 20px"></div> -->
            </p>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  logins,
  enterpriselogincode,
  thirdPartyCheckVaild,
  sendSmsCaptcha,
  checkIsRegist
} from "@/api/api.js";
export default {
  name: "Login",
  data() {
    //校验密码
    let checkPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入密码"));
      } else {
        let reg = /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W#@!~%^&*_]){8,16}/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(
            new Error("请输入8-16位同时包含数字、字母大小写及特殊字符的组合")
          );
        }
      }
    };
    // 短信验证码
    const codeMsg = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("验证码不能为空"));
      } else {
        let reg = /^[0-9]{6}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入六位数字验证码"));
        }
      }
    };
    let checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      } else if (!this.isCellPhone(value)) {
        // 引入methods中封装的检查手机格式的方法
        return callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    };
    return {
      formLabelWidth: "120px",
      register: { image: "", uuid: "" },
      conceal: "../image/iframe/lookn.png",
      show: "../image/iframe/looky.png",
      visible: false,
      codeUrl: "",
      msg: "",
      cookiePass: "",
      loginForm: {
        username: "",
        passwd: "",
        check_uuid: "",
        check_code: "",
        telephone: '',
        msgCode: ""
      },

      //校验账号
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "账号不能为空" },
          // { max: 20, message: "请输入长度不超过20位字符", trigger: "blur" },

        ],
        //校验密码
        passwd: [
          { required: true, message: "密码不能为空", trigger: "blur" },

          // { validator: checkPass, trigger: ["blur","change"] },
        ],
        check_code: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
        ],
        msgCode: [
          {
            required: true,
            message: "短信验证码不能为空",
            trigger: "blur",
          },
          {
            validator: codeMsg,
            trigger: "blur",
          },
        ],
        telephone: [
          {
            required: true,
            message: "手机号不能为空",
            trigger: ["change", "blur"],
          },
          { validator: checkMobile, trigger: ["change", "blur"] },
        ],
      },
      loading: false,
      redirect: undefined,
      activeTab: 1,
      countdown: 0, //倒计时
      countdownNum: 0,
      timer: null, //定时器
      is_pause: false, //是否暂停
      disabled: true,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
    "loginForm.msgCode"(val) {
      if (val > 999999) {
        this.loginForm.msgCode = val.slice(0, 6);
      }
    },
    "loginForm.telephone": {
      handler(newname, oldname) {
        if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(newname)) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      },

    },
    countdown(val) {
      if (val == 0) {
        clearInterval(this.timer);
        // 倒计时结束后需要执行的操作
        this.is_pause = false;
        this.disabled = false;
        // this.loginForm.msgCode = ''
      }
    },
  },
  created() {
    this.initTable();
  },
  methods: {
    goindex() {
      this.$router.push({ name: "index" });
    },
    remberPass() {
      this.$store.state.indexActive = ''
      sessionStorage.removeItem('index')
      this.$router.push({ name: "ChangePassword" });
    },
    showPass(value) {
      this.visible = !this.visible;
    },
    //跳转注册页面
    logon() {
      this.$router.push({ name: "register" });
    },
    //跳转首页
    logo() {
      this.$store.state.indexActive = 51
      sessionStorage.setItem('index', 51)
      this.$router.push({ name: "index" });
    },
    // 切换登录方式
    //验证手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    timeFn() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timer);
          // 倒计时结束后需要执行的操作
          this.is_pause = false;
          this.disabled = false;
        }
      }, 1000);
    },
    // 获取验证码
    getCode() {
      this.loginForm.msgCode = ''
      if (this.loginForm.telephone == "") {
        this.$message.warning("请输入手机号");
        return false;
      }
      checkIsRegist(this.$qs.stringify({ code: this.loginForm.telephone })).then(
        (res) => {
          if (res.code == 1000) {
            if (res.data == true) {
              sendSmsCaptcha(
                this.$qs.stringify({ code: this.loginForm.telephone, exist: true })
              ).then((res) => {
                if (res.code == 1000) {
                  this.$message.success("发送成功请留意短信");
                  this.countdown = "120";
                  this.is_pause = true;
                  this.disabled = true;
                  this.timeFn();
                } else {
                  this.is_pause = false;
                  this.disabled = false;
                  this.$message.error(res.msg);
                }
              });
            } else {
              this.$message.warning("该手机号未注册");
              return false;
            }
          } else {
            this.$message.error(res.msg);
            return false;
          }
        }
      );
    },
    changeLogin(tab) {
      this.activeTab = tab
      this.$refs.loginForm.clearValidate()
    },
    handleLogin() {
      // if (this.countdown == 0) {
      //       this.$message.warning("请重新获取验证码");
      //       return false;
      //     }
      this.$refs.loginForm.validate((valid) => {
        let pas = this.loginForm.passwd;
        if (valid) {
          let obj = {}
          let encPass = ""
          let encPasss = ""
          if (this.activeTab == 2) {
            encPass = this.$Base64.encode(this.loginForm.passwd); //Base64加密
            encPasss = this.$Base64.encode(encPass); //Base64第二次加密
            obj = {
              account: this.loginForm.username,
              passwd: encPasss,
              check_code: this.loginForm.check_code, //验证码
              check_uuid: this.register.uuid,
              loginMethod: 'password'
            };
          } else if (this.activeTab == 1) {
            obj = {
              account: this.loginForm.telephone,
              code: this.loginForm.msgCode,
              loginMethod: 'captcha'
            };
          }
          logins(obj).then((res) => {
            console.log("门户进来的");
            sessionStorage.setItem("menhuCode", "123456");
            if (res.code == "1000") {
              //登陆完成之后 把账号密码一级token 存储起来，方便后续的使用
              sessionStorage.setItem("user", JSON.stringify(res.data));
              // sessionStorage.setItem("passwd", JSON.stringify(encPasss));
              sessionStorage.setItem("token", res.data.token);
              sessionStorage.setItem("userId", res.data.id);

              // ✅ 新增：存储密码过期标识，用于首页判断是否需要强制改密
              // expireFlag: 200 正常 | 1 即将过期 | 0 已过期
              // res.data.expireFlag=0
              // expireFlag: 200正常 | 1即将过期 | 0已过期
              if (res.data.expireFlag === '0' || res.data.expireFlag === 0 ||
                  res.data.expireFlag === '1' || res.data.expireFlag === 1) {
                sessionStorage.setItem("forceChangePwd", String(res.data.expireFlag));
              }
              
              this.$router.push({ name: "index" }); //登录完成之后跳转首
            } else {
              this.$message.error(res.msg);
              // this.$router.go(0);
              // if (res.code == 1002) {
              //   this.msg = "账号或密码不能为空";
              // }
              // if (res.code == 2003 && res.msg == "账号不存在") {
              //   this.msg = "账号不存在";
              // }
              // if (res.code == 2007) {
              //   this.msg = "账号或密码输入错误";
              // }
              // if (res.code == "2008") {
              //   //验证码过期
              //   this.msg = "验证码过期";
              // }
              // if (res.code == "8000") {
              //   this.$router.push({ name: "Empty", query: { msg: res.msg } });
              // }
              // if (res.code == "8001") {
              //   this.$router.push({ name: "Empty", query: { msg: res.msg } });
              // }
              // if (res.code == "2003") {
              //   this.msg = "账号不存在!"
              // }
              if (this.activeTab == 2) {
                this.initTable()
              }
              this.loginForm.passwd = pas;
            }
          });
          // }
        }
      });
    },

    //    看不清换一张
    Changeone() {
      this.initTable(); //输出为：newValue  最新修改的值
    },
    //获取验证码
    initTable() {
      enterpriselogincode().then((res) => {
        if (res.code == "1000") {
          var register = res.data;
          let str = register.img.replace(/\. +/g, "");
          str = str.replace(/[\r\n]/g, "");
          this.register.image = str;
          this.loginForm.check_uuid = res.data.uuid;
          this.register.uuid = register.uuid;
          this.$nextTick(function () {
            this.register.image = str;
            this.register.uuid = register.uuid;
          });
          // console.log(this.register);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
html,
body {
  background: #fff;
}

.looky {
  position: relative;
}

.scrimg {
  position: absolute;
  right: 30px;
  top: 16px;
}

.box_mast {
  height: 90%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rowEditor {
  position: relative;
  margin-bottom: 10px;

  .fa-user-o,
  .fa-lock {
    position: absolute;
    left: 15px;
    top: 13px;
  }

  .fa-eye,
  .fa-eye-slash {
    position: absolute;
    right: 15px;
    top: 13px;
  }

  ::v-deep .el-input__inner {
    padding-left: 36px;
    border-top-style: none;
    border-left-style: none;
    border-right-style: none;
    border-bottom: 2px solid #bbbbbb;
    border-radius: 0px;
  }
}

.hell {
  height: 100%;
  width: 100%;
  text-align: center;

  // display: flex;
  .header {
    width: 100%;
    padding-left: 54px;
    font-weight: bold;
    display: flex;
    height: 80px;
    box-sizing: border-box;
    // line-height: 80px;
    background: #fff;
    align-items: center;
    font-size: 19px;
    color: rgb(38, 38, 39);
    box-shadow: 2px 3px 2px 2px #f0f0f0;
    margin-bottom: 3px;

    img {
      width: 90px;
      height: 60px;
      background-size: 100%;
    }

    p {
      // cursor: pointer;
      line-height: 25px;
      // width: 380px; 
      font-size: 19px;
      text-align: center;
    }
  }
}

.yanzhenma {
  display: flex;
  // justify-content: space-between;
  // align-items: center;
  // width: 600px;
  margin: auto;

  p {
    font-size: 12px;
  }
}

::v-deep .el-form-item__error {
  left: 5px;
}

.box_left {
  width: 50%;
  height: 100%;
  display: flex;
  // justify-content: center;
  // align-items: center;
  // background: url(../assets/loginbj.png) no-repeat 100%;
  background-size: 100% 100%;

  .logo {
    // height: 10%;
    width: 100%;
    margin-top: 22%;
    display: flex;
    flex-direction: column;
    align-items: center;
    // padding-left: 100px;
    font-size: 30px;
    color: #fff;
    font-family: Microsoft YaHei;

    p {
      // cursor:pointer;
      line-height: 50px;
    }
  }
}

.goindex {
  position: absolute;
  top: 23px;
  left: 23px;
  font-size: 14px;
  color: #1890ff;
  cursor: pointer;
}

.login {
  // background: #fff;
  width: 100%;
  margin: 0 auto;
  display: flex;
  background: url("../assets/loginBj.png") 100% 100% no-repeat;
  height: calc(100% - 83px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-size: 100% 100%;
  position: relative;

  h2 {
    line-height: 50px;
    margin-top: 30px;
  }

  .login>p {
    border-bottom: 1px solid #ddd;
    line-height: 40px;
    margin-bottom: 20px;
  }
}

.title {
  margin: 10px auto 46px;
  text-align: center;
  color: #333333;
  width: 144px;
  height: 36px;
  font-size: 24px;
  font-weight: 400;
}

.login-form {
  // border-radius: 6px;
  width: 410px;
  padding: 0 10px;
  box-sizing: border-box;

  /deep/.el-button {
    height: 45px;
    border-radius: 4px;
    width: 100%;
    margin-bottom: 10px;
  }

  /deep/.el-input__inner {
    height: 45px;
    border-radius: 4px;
    // width: 90%;
    margin-bottom: 10px;
  }

  .el-button {
    background-color: #607fea;
    border-color: #607fea;
  }

  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }

  a[data-v-2b7a3d48] {
    color: #607fea;
  }
}

.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}

.login-code {
  width: 33%;
  display: inline-block;
  height: 38px;

  //float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
}

.register {
  float: right;
  color: rgb(24, 144, 255);
}

a {
  color: #1890ff;
  text-decoration: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
}

.ullogo {
  li {
    height: 100px;

    dl {
      display: flex;
      justify-content: center;
      align-items: center;

      dd {
        margin-left: 20px;
        font-size: 20px;
        color: #333333;
      }
    }
  }
}

.login_div {
  box-shadow: 0px 0px 24px rgba(41, 12, 127, 0.1);
  width: 1000px;
  margin: 10px auto;
  height: 526px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 6px;
  background: #ffffff;
  position: relative;

  .titleNew {
    padding: 0 10px;

    img {
      margin-top: 50px;
      width: 400px;
    }
  }
}

.divcss {
  display: flex;
  height: 100%;
  background: rgb(255, 236, 236);
  align-items: center;
  width: 368px;
  margin-left: 20px;

  .xxxx {
    height: 20px;
    width: 20px;
    background: red;
    margin: 10px;
    display: flex;
    color: #fff;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }
}

.el-button.is-circle {
  width: 48px;
  height: 46px;
}

// .scrimg[data-v-2b7a3d48] {
//     top: 22px;
// }

.shortInput:hover {
  background-color: transparent;

  &:-webkit-autofill,
  textarea:-webkit-autofill,
  select:-webkit-autofill {
    -webkit-text-fill-color: transparent !important;
    -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
    background-color: transparent;
    background-image: none;
    transition: background-color 50000s ease-in-out 0s; //背景色透明 生效时长 过渡效果 启用时延迟的时间
  }
}

.tabStyle {
  display: flex;
  justify-content: center;
  line-height: 30px;
  font-size: 18px;
  margin-bottom: 10px;
  cursor: pointer;

  div {
    cursor: pointer;
  }

  div:hover {
    color: #607fea;
  }

  .active {
    color: #607fea;
  }

  span {
    width: 20px;
    height: 4px;
    background: #fff;
    display: block;
    margin: 5px auto;
    border-radius: 10px;
  }

  .actives {
    background: #607fea;
  }
}

.el-button--success.is-disabled,
.el-button--success.is-disabled:active,
.el-button--success.is-disabled:focus,
.el-button--success.is-disabled:hover {
  background: #aab9ec;
  border-color: #aab9ec;
}
</style>
